export default {
      id: "disability-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#disability",
      toString: function () {
        return this.url;
      }
    }